/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        name: "音频",
        type: "module-name"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
                key: "audio_url",
                name: "音频",
                type: "audio"
            },
            {
                key: "head_image",
                name: "封面",
                type: "img",
                memo: "建议宽度：200px*200px"
            },
            {
                key: "title",
                name: "标题",
                type: "text",
                memo: "标题最多30个字",
                max: 30
            },
            {
                key: "is_loop",
                name: "循环",
                type: "radio-box",
                "radio-list": [{
                        label: "不循环",
                        value: 0
                    },
                    {
                        label: "循环",
                        value: 1
                    }
                ]
            }
        ]
    }
];

export default config;